import React from 'react'
import SignupForm from 'components/SignupForm'
import Loader from 'react-loader-spinner'
import COLORS from 'styles/colors'
import StoreButtons from 'components/StoreButtons'
import { PropertyAnnouncement } from 'types/propertyAnnouncement'

type Props = {
  propertyAnnouncement: PropertyAnnouncement
  form: any
  isLoading: boolean
  fbSdkLoaded: boolean
  hasSubmited: boolean
  showStoreButtons: boolean
  error?: any
  onClickFacebook: () => void
  updateUser: () => Promise<void>
  updateField: (event: any) => void
}

const Home = (props: Props) => {
  const views = props.propertyAnnouncement.negative_ratings + props.propertyAnnouncement.positive_ratings
  const interested = props.propertyAnnouncement.positive_ratings
  return (
    <>
      {!!interested && (
        <div className='status'>
          <p className='status__headline'>Seu imóvel possui:</p>
          <div className='status__container'>
            <div className='status__wrapper'>
              <span className='status__number'>{views}</span>
              <span className='status__label'>Visualizações</span>
            </div>
            <div className='status__wrapper'>
              <span className='status__number'>{interested}</span>
              <span className='status__label'>{interested === 1 ? 'Interessado' : 'Interessados'}</span>
            </div>
          </div>
        </div>
      )}
      <div className='form'>
        {props.fbSdkLoaded ? (
          <SignupForm
            form={props.form}
            headline='COMPLETE SEU CADASTRO'
            subheadline='para continuar negociando com estes interessados e outros.'
            submitButtonText='Ver interessados'
            onClickFacebook={props.onClickFacebook}
            onSubmit={props.updateUser}
            updateField={props.updateField}
            isLoading={props.isLoading}
            hasSubmitted={props.hasSubmited}
            sucessMessage={
              'Cadastro finalizado com sucesso! Baixe agora o app do Mellro para ver os interessados em seu imóvel!'
            }
          />
        ) : (
          <Loader
            type='Oval'
            color='#00BFFF'
            height={60}
            width={60}
            style={{ margin: '50px auto', display: 'flex', justifyContent: 'center' }}
          />
        )}
        {props.showStoreButtons && <StoreButtons titleColor={COLORS.greyscale.white} />}
        {Boolean(props.error) && (
          <div style={{ borderRadius: 6, backgroundColor: COLORS.uiSpecific.alert, padding: 4, margin: 16 }}>
            <p style={{ color: 'white', textAlign: 'center' }}>{props.error}</p>
          </div>
        )}
      </div>
      <div className='info'>
        <div className='info__wrapper'>
          <h1 className='info__headline'>VOCÊ GANHA COM A MELLRO:</h1>
          <h3 className='info__subheadline'>
            O Mellro é um aplicativo para alugar direto com o dono, SEM IMOBILIÁRIA, sem taxas, com segurança
            e com você no controle.
          </h3>

          <div className='info__list-section'>
            <p className='info__list-header'>Incluso gratuitamente:</p>
            <ul className='info__list'>
              <li className='info__list-item'>Anúncio e negociação com interessados.</li>
              <li className='info__list-item'>
                Contrato eletrônico gratuito criado baseado no que foi negociado. E sim, é valido legalmente.
              </li>
              <li className='info__list-item'>
                Gerenciamento de pagamentos, reajustes anuais, cobrança de juros por atraso, etc. Tudo isso de
                forma automática.
              </li>
              <li className='info__list-item'>
                Fechamento de contrato automático. Na hora de fechar o contrato, o aplicativo fecha a conta e
                passa a régua, informa quanto tem de divida e gera as cobranças.
              </li>
            </ul>
          </div>

          <div className='info__list-section'>
            <p className='info__list-header'>Opcionais pagos:</p>
            <ul className='info__list'>
              <li className='info__list-item'>
                Verificação de crédito SERASA/SPC de interessados/moradores.
              </li>
              <li className='info__list-item'>
                Seguro fiança embutido no aluguel garantindo 30 meses de recebimento de aluguel, condomínio,
                iptu e outros. Vem também boleto de cobrança de aluguel que cai direto na sua conta bancária.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default Home
